import React from 'react';
import {
  Shield,
  SolarPower,
  Home,
  Bolt,
  Star,
  AutoAwesome,
  Phone,
  Info,
  HelpOutline,
  VideoCameraFront,
} from '@mui/icons-material';
import DoubleEighthNoteIcon from '../icons/DoubleEighthNoteIcon';
import ClimateSunSnowIcon from '../icons/ClimateSunSnowIcon';
import DashboardWidgetsIcon from '../icons/DashboardWidgetsIcon';
import type { BottomNavItemId } from '../../constants/bottomNav';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const ICONS: Record<BottomNavItemId, React.ComponentType<SvgIconProps>> = {
  alarm: Shield,
  video: VideoCameraFront,
  realtime: SolarPower,
  climate: ClimateSunSnowIcon,
  music: DoubleEighthNoteIcon,
  home: Home,
  widgets: DashboardWidgetsIcon,
  reports: Bolt,
  favorites: Star,
  assistant: AutoAwesome,
  phone: Phone,
  info: Info,
  help: HelpOutline,
};

interface BottomNavIconProps {
  id: BottomNavItemId;
  active?: boolean;
  editing?: boolean;
  fontSize?: number;
}

export const BottomNavIcon: React.FC<BottomNavIconProps> = ({
  id,
  active = false,
  editing = false,
  fontSize = 18,
}) => {
  const Icon = ICONS[id];
  if (!Icon) return null;
  let color = '#fff';
  if (editing) color = '#4caf50';
  else if (active) color = '#2391FF';
  return <Icon sx={{ color, fontSize }} />;
};

export default BottomNavIcon;
